/* eslint arrow-body-style: ["error", "as-needed", { requireReturnForObjectLiteral: true }]*/

import React from "react";
import Select, { components } from "react-select";
import classNames from "classnames";

import { Feedback, Label } from "components/Inputs";

import _ from "lodash";
const Option = props => {
	const option = props.options.find(option => option.value === props.value);
	if (!option.item) {
		return false;
	}
	return (
		<components.Option {...props}>
			<div className="option-left">
				<h5>{_.get(option, "item.name")}</h5>
			</div>
		</components.Option>
	);
};

export default class Lookup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { name, tenancies, className, children, required, defaultState, onChange } = this.props;
		if (!!_.get(tenancies, "length")) {
			return (
				<div
					className={classNames("form-group", `form-control-${name}`, className, {
						className,
						"is-required": required && (required.tenancy || required.tenancy_id),
						"has-danger":
							defaultState && defaultState.errors && (defaultState.errors.tenancy || defaultState.errors.tenancy_id)
					})}
				>
					<Label {...this.props} name="tenancy" />
					<Select
						name={name}
						autoFocus={false}
						closeMenuOnSelect={false}
						components={{ Option }}
						value={this.state.value}
						onChange={option => this.setState({ value: option }, () => onChange && onChange(option.item))}
						options={_.map(tenancies, tenancy => {
							return { item: tenancy, value: tenancy.id, label: tenancy.name };
						})}
					/>
					<Feedback {...this.state} {...this.props} name="tenancy" />
					{children && children}
				</div>
			);
		}
		return false;
	}
}
